import { generateTableSlice } from "./tableSlice";

const sliceSuperAdminTable = generateTableSlice("superAdmin");

export const ActionsSuperAdminTable = sliceSuperAdminTable.actions;
export const ReducerSuperAdminTable = sliceSuperAdminTable.reducer;
